/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { Icon } from "react-native-elements";
import { DetailInfoV } from "../../../../../../widgets/DetailInfoV";
//import blueprint from "../config/default-blueprint.json";

//const BP = blueprint.ProvDetailInfo;

export interface IProvDetailInfo {
    title?: string;
    aboutProvInfo?: string;
    provInfoList?: any[];
    onProvListItemPress?: (item: any) => void;
    bp?: string;
    info?:any[];
}

export const ProvDetailInfo = ({
    title,
    aboutProvInfo,
    provInfoList,
    onProvListItemPress,
    bp,
}: IProvDetailInfo): JSX.Element => {
    const _renderSvgIcon = (item: any) => {
        let _key = item?.label.toLowerCase();
        if (_key === "website") {
            return (
                <Icon
                    type={"simple-line-icon"}
                    name={"globe"}
                    size={13}
                    style={{ margin: 5 }}
                />
            );
        } else if (_key === "email" || _key === "mail") {
            return (
                <Icon
                    type={"simple-line-icon"}
                    name={"envelope"}
                    size={13}
                    style={{ margin: 5 }}
                />
            );
        } else if (
            _key === "phone" ||
            _key === "contact" ||
            _key === "mobile"
        ) {
            return (
                <Icon
                    type={"simple-line-icon"}
                    name={"phone"}
                    size={13}
                    style={{ margin: 5 }}
                />
            );
        } else if (_key === "address") {
            return (
                <Icon
                    type={"simple-line-icon"}
                    name={"location-pin"}
                    size={13}
                    style={{ margin: 5 }}
                />
            );
        } else {
            return (
                <Icon
                    type={"simple-line-icon"}
                    name={"info"}
                    size={13}
                    style={{ margin: 5 }}
                />
            );
        }
    };

    const _renderProdInfo = () => {
        if (title || aboutProvInfo || provInfoList) {            
            const _provInfoList = provInfoList?.filter(obj => obj.label !== "geoJSON" && obj.label !== '');
            return (
                <DetailInfoV
                    title={title}
                    aboutInfo={aboutProvInfo}
                    infoList={_provInfoList}
                    onListItemPress={onProvListItemPress}
                    renderSvgIcon={_renderSvgIcon}
                    bp={bp}
                />
            );
        }
    };

    return <>{_renderProdInfo()}</>;
};

ProvDetailInfo.defaultProps = {
    // title: BP.title,
    // aboutProvInfo: BP.aboutProvInfo,
    // provInfoList: BP.provInfoList,
} as Partial<IProvDetailInfo>;
